/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/tableGrid';
import {
  manuFactureChildHead,
  ProviderHead,
  manuFactureHead,
  groupTableHead,
  superClientModalHead,
  clientGroupPlanHead,
  contractTableHead,
} from './gridComponents/copyContactTableHead';
import {
  getAllManufacturer,
  getCopyContactDropdownList,
  getGetAllProviderList,
  getAllClientGroupList,
  getAllClientGroupByPlanList,
  getAllClientListData,
  getGetAllContractList,
  getExistingContactList,
} from '../../Manufacturer/store/ManufacturerAction';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import showPreloader from '../../../../interceptor/store/Actions';

export default function CopyContactComponent(props) {
  const dispatch = useDispatch();
  const ManufacturerData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer?.manufacturerList?.data;
  });
  const createMFG = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.selectManufacturerData
      .createManufacturer;
  });
  const getSelectOptions = useSelector(
    (state) => state.sharedState.ManufacturerReducer.getAllDropdownValues
  );
  const FetchAllClientGroupList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientGroupList
  );
  const FetchAllClientGroupPlanList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientGroupPlanList
  );
  const FetchAllClientListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allClientListData
  );
  const FetchAllContractListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allContractListData
  );
  const FetchAllProviderListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allProviderListData
  );
  const FetchAllExistingContactList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.getAllExistingContactList
  );
  const [showAll, setShowAll] = React.useState(false);
  const superChildRef = React.useRef(null);
  const childRef = React.useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [gridApi1, setGridApi1] = useState(null);
  const [columnApi1, setColumnApi1] = useState(null);
  const [gridParams, setGridParams] = React.useState('');
  const [childGridParams, setChildGridParams] = React.useState('');
  const [applyFilter, setApplyFilter] = React.useState(false);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [childApplyFilter, setChildApplyFilter] = React.useState(false);
  const [ChildTotalResultCount, setChildTotalResultCount] = React.useState(0);
  const [selectedOption, setSelectedOption] = React.useState('MFG');
  const [rowData, setRowData] = React.useState([]);
  const [childData, setChildData] = React.useState([]);
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [spinnerLoaderFordChild, setSpinnerLoaderFordChild] =
    React.useState(false);

  const { setSelectedContact, mfgId, isEnablebyRole } = props;

  // FetchAllExistingContact select MFg id
  React.useEffect(() => {
    setChildData(FetchAllExistingContactList);
    setSpinnerLoaderFordChild(false);
    if (selectedOption === 'PROVIDER') {
      setSpinnerLoader(false);
  
      // setTimeout(() =>    dispatch(showPreloader(false)), 500);
    }
    // if (FetchAllExistingContactList && FetchAllExistingContactList.length > 0) {
    //   // setTimeout(() => {
    //     if (childGridParams !== '')
    //       childGridParams &&
    //         childGridParams.api &&
    //         childGridParams.api.forEachNode((node) =>
    //           node.rowIndex ? 1 : node.setSelected(true)
    //         );
    //     childGridParams &&
    //       childGridParams.api &&
    //       childGridParams.api.setFilterModel(null);
    //   // }, 100);
    // }
  }, [FetchAllExistingContactList]);
  React.useEffect(() => {
    if (
      childGridParams &&
      childGridParams.api &&
      FetchAllExistingContactList &&
      FetchAllExistingContactList.length > 0
    ) {
      // Select the first row
      childGridParams.api.forEachNode((node) =>
        node.rowIndex ? 1 : node.setSelected(true)
      );
      // Reset filters
      childGridParams.api.setFilterModel(null);
    }
  }, [childGridParams, FetchAllExistingContactList]);
  // set manufacturer list on page load
  React.useEffect(() => {
    if (ManufacturerData && ManufacturerData.length > 0) {
      setRowData(
        ManufacturerData.filter((x) => {
          if (!showAll) {
            return x.mfgId === props.mfgId;
          }
          return x;
        })
      );
    }
  }, [ManufacturerData]);
  React.useEffect(() => {
    if (
      FetchAllProviderListData &&
      FetchAllProviderListData.length > 0 &&
      selectedOption === 'PROVIDER'
    ) {
      setSpinnerLoader(false);
      // setTimeout(() => dispatch(showPreloader(false)), 500);
    }
  }, [FetchAllProviderListData]);
  const handleSetDataOnGrid = (val) => {
    if (ManufacturerData && ManufacturerData.length > 0) {
      if (selectedOption === 'CG') {
        setRowData(FetchAllClientGroupList);
      } else if (selectedOption === 'CGP') {
        setRowData(FetchAllClientGroupPlanList);
      } else if (selectedOption === 'CLIENT') {
        setRowData(FetchAllClientListData);
      } else if (selectedOption === 'CONTRACT') {
        setRowData(FetchAllContractListData);
      } else if (selectedOption === 'PROVIDER') {
        setRowData(FetchAllProviderListData);
      } else {
        setRowData(
          ManufacturerData.filter((x) => {
            if (!val) {
              return x.mfgId === props.mfgId;
            }
            return x;
          })
        );
      }
      // setTimeout(() => {
      //   if (gridParams !== '')
      //     gridParams &&
      //       gridParams.api &&
      //       gridParams.api.forEachNode((node) =>
      //         node.rowIndex ? 1 : node.setSelected(true)
      //       );
      //   gridParams && gridParams.api && gridParams.api.setFilterModel(null);
      // }, 100);
    }
  };
  // set Row Data if change dropdown values
  React.useEffect(() => {
    handleSetDataOnGrid(showAll);
  }, [selectedOption]);
  React.useEffect(() => {
    if (
      gridParams &&
      gridParams.api &&
      rowData &&
      rowData.length > 0
    ) {
      // Select the first row
      gridParams.api.forEachNode((node) =>
        node.rowIndex ? 1 : node.setSelected(true)
      );
      // Reset filters
      gridParams.api.setFilterModel(null);
    }
  }, [gridParams, rowData]);
  // select single row after call
  const handleOnSelect = (e) => {
    if (setSelectedContact) setSelectedContact(null);
    setChildData([]);
    getSelectedRow(e.data, selectedOption);
  };
  // set contact detail on select child table
  const childSelect = (e) => {
    if (setSelectedContact)
      setSelectedContact(e.api.getSelectedRows() && e.api.getSelectedRows()[0]);
  };
  // select row on ag-grid table
  const getSelectedRow = (data, selectVal) => {
    dispatch(getExistingContactList(null));
    setChildData([]);
    if (selectVal === 'CG' && data.cg_id) {
      getExistingContacts(data.cg_id, 'CG');
    } else if (selectVal === 'CGP' && data.cgpId) {
      getExistingContacts(data.cgpId, 'CGP');
    } else if (selectVal === 'CLIENT' && data.clientId) {
      getExistingContacts(data.clientId, 'CLIENT');
    } else if (selectVal === 'CONTRACT') {
      getExistingContacts(data.contractNum, 'CONTRACT');
    } else if (selectVal === 'MFG' && data.mfgId) {
      getExistingContacts(data.mfgId, 'MFG');
    } else if (selectVal === 'PROVIDER' && data.providerTypeCDAndId) {
      getExistingContacts(data.providerTypeCDAndId, 'TYPEPROV');
    }
  };

  // set All dropdown option and data
  React.useEffect(() => {
    setChildApplyFilter(false);
    setApplyFilter(false);
    dispatch(getAllManufacturer({ mfgId: null, showAllInd: true }));
    setSpinnerLoader(true);
    dispatch(getCopyContactDropdownList(''));
    dispatch(getAllClientGroupList(''));
    dispatch(getAllClientGroupByPlanList(''));
    dispatch(getAllClientListData(''));
    dispatch(getGetAllProviderList(''));
    dispatch(getGetAllContractList({ showAllInd: true, mfgId: null }));
    dispatch(getExistingContactList(null));
    if (!createMFG && selectedOption === 'MFG') {
      const Obj = { mfgId: mfgId };
      getSelectedRow(Obj, 'MFG');
    }
  }, []);
  // handing by default 1st row selection function
  const onGridReady = useCallback((params) => {
    setGridParams(params);
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    params.api.forEachNode((node) =>
      node.rowIndex ? 1 : node.setSelected(true)
    );
    setSpinnerLoader(false);
  });
  // handing by default 1st row selection function
  const onGridReadyChild = useCallback((params) => {
    setChildGridParams(params);
    setGridApi1(params.api);
    setColumnApi1(params.columnApi);
    params.api.forEachNode((node) =>
      node.rowIndex ? 1 : node.setSelected(true)
    );
  });
  // onchange event on dropdown
  const handleOnChange = (e) => {
    setShowAll(false);
    setChildData([]);
    setRowData([]);
    setSpinnerLoaderFordChild(true);
    if (e.target.value === 'PROVIDER') {
      setSpinnerLoader(true);
    }
    setSelectedOption(e.target.value);
    if (
      e.target.value === 'CG' &&
      FetchAllClientGroupList &&
      FetchAllClientGroupList.length > 0
    ) {
      getSelectedRow(FetchAllClientGroupList[0], e.target.value);
    } else if (
      e.target.value === 'CGP' &&
      FetchAllClientGroupPlanList &&
      FetchAllClientGroupPlanList.length > 0
    ) {
      getSelectedRow(FetchAllClientGroupPlanList[0], e.target.value);
    } else if (
      e.target.value === 'CLIENT' &&
      FetchAllClientListData &&
      FetchAllClientListData.length > 0
    ) {
      getSelectedRow(FetchAllClientListData[0], e.target.value);
    } else if (
      e.target.value === 'CONTRACT' &&
      FetchAllContractListData &&
      FetchAllContractListData.length > 0
    ) {
      getSelectedRow(FetchAllContractListData[0], e.target.value);
    } else if (
      e.target.value === 'PROVIDER' &&
      FetchAllProviderListData &&
      FetchAllProviderListData.length > 0
    ) {
      getSelectedRow(FetchAllProviderListData[0], e.target.value);
    } else if (
      e.target.value === 'MFG' &&
      ManufacturerData &&
      ManufacturerData.length > 0
    ) {
      getSelectedRow(
        ManufacturerData.filter((x) => {
          if (!showAll) {
            return x.mfgId === props.mfgId;
          }
          return x;
        })[0],
        e.target.value
      );
    } else{
      setSpinnerLoaderFordChild(false)
    }
  };
  // handling  clear filter
  const handleClearFilter = () => {
    childRef && childRef.current && childRef.current.clearFilters();
    setApplyFilter(false);
  };
  //  handling  clear filter
  const handleClearFilterChild = () => {
    childRef && childRef.current && childRef.current.clearFilters();
    setChildApplyFilter(false);
  };
  // get existing contact list
  const getExistingContacts = (key, keyTypeCD) => {
    setSpinnerLoaderFordChild(true);
    handleClearFilter();
    handleClearFilterChild();
    dispatch(getExistingContactList({ key: key, keyTypeCD: keyTypeCD }));
  };
  // handling Apply filter
  const onFilterChanged = useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      (e.api.getFilterModel() && Object.keys(e.api.getFilterModel())).length > 0
    ) {
      setApplyFilter(true);
    } else {
      setApplyFilter(false);
    }
  }, []);
  // Apply Filter
  const onFilterChangedChild = useCallback((e) => {
    setChildTotalResultCount(e.api.getDisplayedRowCount());
    if (
      (e.api.getFilterModel() && Object.keys(e.api.getFilterModel())).length > 0
    ) {
      setChildApplyFilter(true);
    } else {
      setChildApplyFilter(false);
    }
  }, []);
  // Ag-grid framework component
  const frameworkComponents = {
    nameRenderMFG: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.mfgName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderClient: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.clientName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderGroup: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.groupName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderContract: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.contractName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderProvider: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.name;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderPlan: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.planName;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  const frameworkComponentsChild = {
    nameRenderChild: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.contactName;
      if (name && name.length > 15) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    copNameRender: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.corpName;
      if (name && name.length > 15) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  return (
    <>
      <Spinner load={spinnerLoader || spinnerLoaderFordChild} />
      <div
        data-testid='copy-contact-popup'
        id='copy-contact-popup'
        className='common-popup'
      >
        <div className='panel tBillPanel-space devider-line pb-0'>
          <form autoComplete='off'>
            <div className='form-wrapper'>
              <div className='mui-custom-form with-select  mfg-dropdown-width'>
                <TextField
                  id='drop-down'
                  label='Entity Type'
                  defaultValue={selectedOption}
                  data-testid='drop-down'
                  fullWidth
                  required
                  select
                  disabled={!isEnablebyRole}
                  placeholder=''
                  inputProps={{ maxlength: 11, id: 'drop-down' }}
                  InputLabelProps={{ shrink: true }}
                  value={selectedOption}
                  onChange={(e) => handleOnChange(e)}
                >
                  {getSelectOptions?.length > 0 &&
                    getSelectOptions?.map((x) => {
                      return (
                        <MenuItem key={x.value} value={x.value}>
                          {x.text}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </div>
              <div className='mui-custom-form input-md'>
                <div className='sub-radio text-black sub-label'>
                  <FormControlLabel
                    style={{ marginTop: '27px' }}
                    control={
                      selectedOption === 'MFG' ? (
                        <Checkbox
                          value={showAll}
                          checked={showAll}
                          onClick={(e) => {
                            dispatch(getExistingContactList(null));
                            setShowAll(e.target.checked);
                            setChildData([]);
                            handleSetDataOnGrid(e.target.checked);
                            if (
                              ManufacturerData &&
                              ManufacturerData.length > 0
                            ) {
                              if (!createMFG) {
                                const tempObj = ManufacturerData.filter((x) => {
                                  if (!e.target.checked) {
                                    return x.mfgId === props.mfgId;
                                  }
                                  return x;
                                });
                                if (tempObj && tempObj.length > 0) {
                                  getSelectedRow(tempObj[0], selectedOption);
                                }
                              } else {
                                const newObj = ManufacturerData.filter((x) => {
                                  if (!e.target.checked) {
                                    return [];
                                  }
                                  return x;
                                });
                                if (newObj && newObj.length > 0) {
                                  getSelectedRow(newObj[0], selectedOption);
                                }
                              }
                            }
                          }}
                          color='primary'
                        />
                      ) : (
                        <Checkbox value checked disabled color='primary' />
                      )
                    }
                    label='Show All'
                    data-testid='showAll'
                  />
                </div>
              </div>
            </div>
          </form>
          <div className='panel-header mt-3'>
            <div className='float-left mt-2'>
              <p className='no-margin tbl-help-text'>
                * Click on the record to view the details
              </p>
            </div>

            <div className='float-right th-icon-group mt-2'>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='filter-tooltip'>Reset All Filters</Tooltip>
                }
              >
                {applyFilter ? (
                  // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
                  <div
                    className='th-icon ic-filter-activate'
                    data-testid='handleClearFilter'
                    role='button'
                    onClick={handleClearFilter}
                  >
                    <span className='ic-title'> Filter </span>{' '}
                  </div>
                ) : (
                  <div
                    data-testid='handleClearFilter'
                    className='th-icon ic-filter'
                  >
                    <span className='ic-title'> Filter </span>{' '}
                  </div>
                )}
              </OverlayTrigger>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id='history-tooltip'> Actions </Tooltip>}
              >
                <div className='th-icon ic-actions'>
                  {' '}
                  <PDFExportPanel
                    gridApi={gridApi}
                    columnApi={columnApi}
                    fileName={
                      selectedOption === 'CG'
                        ? 'Contract-CG'
                        : selectedOption === 'CGP'
                        ? 'Contract-CGP'
                        : selectedOption === 'CLIENT'
                        ? 'Contract-Client'
                        : selectedOption === 'CONTRACT'
                        ? 'Contract-Contract'
                        : selectedOption === 'PROVIDER'
                        ? 'Contract-Provider'
                        : 'Contract-MFG'
                    }
                    childRef={childRef}
                  />
                </div>
              </OverlayTrigger>
            </div>
            <div className='clearfix' />
          </div>
        </div>

        <div className='panel tBillPanel-space pb-0'>
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner'>
            <div className='frr-tbl-with-feature'>
              {ManufacturerData && ManufacturerData.length > 0 ? (
                <TableGrid
                  ref={childRef}
                  onGridReady={onGridReady}
                  gridHeight={350}
                  rowData={rowData}
                  columnDefs={
                    selectedOption === 'CG'
                      ? groupTableHead
                      : selectedOption === 'CGP'
                      ? clientGroupPlanHead
                      : selectedOption === 'CLIENT'
                      ? superClientModalHead
                      : selectedOption === 'CONTRACT'
                      ? contractTableHead
                      : selectedOption === 'PROVIDER'
                      ? ProviderHead
                      : manuFactureHead
                  }
                  fileName={
                    selectedOption === 'CG'
                      ? 'Contract-CG'
                      : selectedOption === 'CGP'
                      ? 'Contract-CGP'
                      : selectedOption === 'CLIENT'
                      ? 'Contract-Client'
                      : selectedOption === 'CONTRACT'
                      ? 'Contract-Contract'
                      : selectedOption === 'PROVIDER'
                      ? 'Contract-Provider'
                      : 'Contract-MFG'
                  }
                  cellClickedListener={(e) => handleOnSelect(e)}
                  onFilterChanged={onFilterChanged}
                  data-testid='onEditingStopped'
                  setTotal={setTotalResultCount}
                  childPopup
                  frameworkComponents={frameworkComponents}
                  navigateToNextCell={navigateToNextCell}
                  // tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                />
              ) : null}
            </div>
          </div>

          <p className='total-results' tabIndex='0'>
            Total Results:<b>{totalResultCount?.toLocaleString('en-US')}</b>
          </p>
          <div className='panel-header mt-3'>
            <div className='float-left mt-2'>
              <label className='frr-label-font'>Available Contacts</label>
            </div>
            <div className='float-right th-icon-group mt-2'>
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='filter-tooltip'>Reset All Filters</Tooltip>
                }
              >
                {childApplyFilter ? (
                  // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                  <div
                    className='th-icon ic-filter-activate'
                    data-testid='childHandleClearFilter'
                    role='button'
                    onClick={handleClearFilterChild}
                  >
                    <span className='ic-title'> Filter </span>{' '}
                  </div>
                ) : (
                  <div
                    data-testid='childHandleClearFilter'
                    className='th-icon ic-filter'
                  >
                    <span className='ic-title'> Filter </span>{' '}
                  </div>
                )}
              </OverlayTrigger>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id='history-tooltip'> Actions </Tooltip>}
              >
                <div className='th-icon ic-actions'>
                  {' '}
                  <PDFExportPanel
                    gridApi={gridApi1}
                    columnApi={columnApi1}
                    fileName='Contract-Available Contacts'
                    childRef={superChildRef}
                  />
                </div>
              </OverlayTrigger>
            </div>
          </div>
          <div className='clearfix' />
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner'>
            <div className='frr-tbl-with-feature'>
              {ManufacturerData && ManufacturerData.length > 0 ? (
                <TableGrid
                  ref={superChildRef}
                  rowData={childData}
                  onGridReady={onGridReadyChild}
                  columnDefs={manuFactureChildHead}
                  gridHeight={350}
                  onSelectionChanged={(e) => childSelect(e)}
                  onFilterChanged={onFilterChangedChild}
                  setTotal={setChildTotalResultCount}
                  rowSelection='single'
                  childPopup
                  data-testid='onEditingStopped1'
                  fileName='Contract-Available Contacts'
                  frameworkComponents={frameworkComponentsChild}
                  navigateToNextCell={navigateToNextCell}
                  // tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                />
              ) : null}
            </div>
          </div>
          <p className='total-results' tabIndex='0'>
            Total Results:
            <b>{ChildTotalResultCount?.toLocaleString('en-US')}</b>
          </p>
        </div>
      </div>
    </>
  );
}
